import { SurgeryProcedureInterface } from '@components/RequestForm/SurgeryInformation/SurgeryInformationInterface';
import { SecondarySurgeon } from '@data/secondarySurgeon/secondarySurgeon';
import DocumentRequestFormType from '@interfaces/RequestForm/forms/DocumentRequestFormType';
import { DEFAULT_SELECTION_NONE } from '@utilities/constants';

export const secondarySurgeonFormStateToPayload = (procedure: SurgeryProcedureInterface | DocumentRequestFormType): SecondarySurgeon | null => {
	const { secondarySurgeon, customSecondarySurgeon } = procedure;

	if (secondarySurgeon?.isCustom && customSecondarySurgeon) {
		return { id: null, name: customSecondarySurgeon };
	}

	if (secondarySurgeon?.id && secondarySurgeon.id !== DEFAULT_SELECTION_NONE) {
		return {
			id: secondarySurgeon.id,
			name: secondarySurgeon.name,
		};
	}

	return null;
};
